import { Record } from 'immutable'

export const SET_RESERVATION_FILTER = 'SET_RESERVATION_FILTER'

export const STATUS = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
}

/**
 * Reducer section
 */
const initialState = {}

const ReservationFilter = new Record(initialState)

// FlowType
type Action = {
  type: string,
  payload: {},
}

export function reducer(state: Record = initialState, action: Action) {
  switch (action.type) {
    case SET_RESERVATION_FILTER:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setReservationFilter(payload: ReservationFilter) {
  return {
    type: SET_RESERVATION_FILTER,
    payload,
  }
}
